import React from "react";
import { useDrag, useDrop } from "react-dnd";
import styled from "styled-components";

import { ImportMainWidget } from "@pages/CampaignBlocksPageV2/ImportWidget/ImportMainWidget";

const Container = styled.div``;

const BlockItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  flex-shrink: 0;
  border-radius: 16px;
  background: linear-gradient(181deg, #fff 50%, #e9fff9 99.52%), #fff;
  box-shadow: 0px 4px 16px 0px #def4f5;
  cursor: grab;
`;

export const DraggableBlockWidget = ({
  item,
  index,
  moveBlock = () => undefined,
  blockType = "WIDGETS",
  campaignWidth,
  campaignHeight,
  onHandleOpenSelectImage = () => undefined,
  onHandleUpdateWidgetInputValue = () => undefined,
  onHandleDeleteWidget = () => undefined,
}) => {
  const [, ref] = useDrag({
    type: "BLOCK",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "BLOCK",
    hover: (draggedItem) => {
      if (draggedItem?.index !== index) {
        moveBlock(draggedItem?.index, index);
        draggedItem.index = index;
      }
    },
  });

  return (
    <Container ref={(node) => ref(drop(node))}>
      <BlockItem>
        <ImportMainWidget
          item={item}
          index={index}
          campaignWidth={campaignWidth}
          campaignHeight={campaignHeight}
          onHandleOpenSelectImage={onHandleOpenSelectImage}
          onHandleUpdateWidgetInputValue={onHandleUpdateWidgetInputValue}
          onHandleDeleteBlock={onHandleDeleteWidget}
        />
      </BlockItem>
    </Container>
  );
};
